<template>
  <div class="card modal-card is-min-width-500" v-if="!!produit">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-5">
              {{ libelle }}
            </h1>
            <p>{{ $t('optionBlocage.informationOptionBlocage.duAu',
              {
                jourDepart: date.jourDepart, dateDebut: date.dateDebut, dateFin: date.dateFin,
                semaine: semaine
              }) }}</p>
            <p>{{ $t('optionBlocage.informationOptionBlocage.format',
              { libelleFormat: getFormatReseau(produit.produitReseau.formatId) }) }} -
              {{ $t('optionBlocage.informationOptionBlocage.departement',
                { departement: produit.produitReseau.adresse.departement }) }}</p>
          </div>
        </div>
      </div>
      <div class="card-content">
        <info-produit-associes v-if="produitsAssocies.length > 0" :produits="produitsAssocies">
        </info-produit-associes>
        <option-blocage-lignes v-for="(affectation, index) in getAllAffectationOfProduct"
        :idReseau="idProduitReseau"
          :affectation="affectation" :objectif="objectif"
          :key="index" :anneeSemaine="anneeSemaine"
          :produitReseau="produit.produitReseau"
          :isLast="index !== getAllAffectationOfProduct.length - 1">
        </option-blocage-lignes>
        <option-blocage-lignes-disponible :idReseau="idProduitReseau"
        :affectations="getAllAffectationOfProduct.length"
          :nbFaceDispo="nbFaceDispo" :anneeSemaine="anneeSemaine"
          :produitReseau="produit.produitReseau">
        </option-blocage-lignes-disponible>
        <div class="card-content pdt-0 center mgt-20px">
          <div class="button" @click="$emit('close')">
            {{ $t('optionBlocage.informationOptionBlocage.fermer') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  TYPE_DEVIS, TYPE_COMMANDE, ETAT_FACTURE, ETAT_ENREGISTRE, ETAT_FACTURE_PARTIELLEMENT,
  ETAT_COMMANDE_PARTIELLEMENT, ETAT_BROUILLON, ETAT_SANSSUITE,
} from '@/configuration/devisConf';
import {
  BLOQUE,
  EN_ATTENTE_RELANCE_OPTION,
  OPTION,
  RELANCE_OPTION,
  SANS_SUITE,
  INDISPONIBLE,
  ANNULATION,
} from '@/configuration/optionBlocage/optionBlocage';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import optionBlocageLignes from '@/components/optionBlocage/optionBlocageLignes';
import optionBlocageLignesDisponible from '@/components/optionBlocage/optionBlocageLignesDisponible';
import moment from 'moment';
import infoProduitAssocies from '@/components/optionBlocage/infoProduitAssocies';
import genererCalculAutoTlpeSemaine
  from '@/services/dcf/tlpe/model/genererCalculAutoTlpeSemaine';
import { calculTlpeSemaine } from '@/api/gabed/materiel';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');

export default {
  name: 'ReseauOptionBlocageContainer',
  props: {
    allAffectationOfProduct: {
      type: Array,
      required: true,
    },
    nbFaceDispo: {
      type: Number,
      required: true,
    },
    stock: {
      type: Number,
      required: true,
    },
    libelle: {
      type: String,
      required: true,
    },
    date: {
      type: Object,
      required: true,
    },
    semaine: {
      type: String,
      required: true,
    },
    idProduitReseau: {
      type: String,
      required: true,
    },
    objectif: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      EN_ATTENTE_RELANCE_OPTION: EN_ATTENTE_RELANCE_OPTION,
      affectationWithAllData: null,
      produitsAssocies: [],
    };
  },
  components: {
    optionBlocageLignes,
    optionBlocageLignesDisponible,
    infoProduitAssocies,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    ...ProduitReseauTempo.mapGetters({
      produit: 'produitReseau',
    }),
    getAllAffectationOfProduct() {
      if (!this.allAffectationOfProduct) return [];
      let affectationFinalList = this.getAffectationSort(this.allAffectationOfProduct,
        BLOQUE, TYPE_COMMANDE, ETAT_FACTURE);
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, BLOQUE, TYPE_COMMANDE, ETAT_FACTURE_PARTIELLEMENT,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, BLOQUE, TYPE_COMMANDE, ETAT_ENREGISTRE,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, BLOQUE, TYPE_DEVIS, ETAT_ENREGISTRE,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, RELANCE_OPTION, TYPE_DEVIS, ETAT_ENREGISTRE,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, EN_ATTENTE_RELANCE_OPTION, TYPE_DEVIS, ETAT_ENREGISTRE,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, BLOQUE, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, RELANCE_OPTION, TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, EN_ATTENTE_RELANCE_OPTION,
        TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, BLOQUE, TYPE_DEVIS, ETAT_BROUILLON,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, RELANCE_OPTION, TYPE_DEVIS, ETAT_BROUILLON,
      ));
      affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
        this.allAffectationOfProduct, EN_ATTENTE_RELANCE_OPTION,
        TYPE_DEVIS, ETAT_BROUILLON,
      ));

      affectationFinalList = affectationFinalList.concat(
        this.getAffectationOptionSort(this.allAffectationOfProduct),
      );

      [SANS_SUITE, INDISPONIBLE, ANNULATION].forEach(etatObtenu => {
        [ETAT_FACTURE, ETAT_FACTURE_PARTIELLEMENT, ETAT_ENREGISTRE].forEach(etat => {
          affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
            this.allAffectationOfProduct, etatObtenu, TYPE_COMMANDE, etat,
          ));
        });
        [ETAT_ENREGISTRE, ETAT_COMMANDE_PARTIELLEMENT,
          ETAT_BROUILLON, ETAT_SANSSUITE].forEach(etat => {
          affectationFinalList = affectationFinalList.concat(this.getAffectationSort(
            this.allAffectationOfProduct, etatObtenu, TYPE_DEVIS, etat,
          ));
        });
      });
      return affectationFinalList;
    },
    anneeSemaine() {
      return moment(this.date.dateDebut, 'DD/MM/YYYY').format('YYYY') + this.semaine.substr(0, 2);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.format]);
      if (this.idProduitReseau) {
        await this.actionLoadReseau({ id: this.idProduitReseau });
        const dateDepart = moment(this.date.dateDebut, 'DD/MM/YYYY');
        this.produitsAssocies = this.produit.liaisonsTarif.filter((produit) => {
          return (!produit.produitEnfant
            || produit.produitEnfant.supportCommercial.societeId === this.societeActiveId)
            && ((dateDepart.isBetween(moment(produit.dateDebut), moment(produit.dateFin)))
              || (!produit.dateFin && dateDepart.isSameOrAfter(moment(produit.dateDebut))));
        });
        const promises = [];
        for (let i = 0; i < this.produitsAssocies.length; i += 1) {
          const produitAssocie = this.produitsAssocies[i];
          for (let j = 0; j < produitAssocie.liaisonsTarif.length; j += 1) {
            const liaisonTarif = produitAssocie.liaisonsTarif[j];
            if (liaisonTarif.calculAutomatique === true) {
              const tlpeSemaine = genererCalculAutoTlpeSemaine();

              tlpeSemaine.produitId = this.idProduitReseau;
              tlpeSemaine.anneeSemaine = this.anneeSemaine;
              tlpeSemaine.quantiteSouhaitee = this.stock;
              promises.push(calculTlpeSemaine(tlpeSemaine)
                .then(response => {
                  const montantTlpe = response.data.result;
                  liaisonTarif.prixUnitaire = montantTlpe?.montant ?? 0;
                }));
            }
          }
        }
        await Promise.all(promises);
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...ProduitReseauTempo.mapActions({
      actionLoadReseau: 'loadReseau',
    }),
    getLibelleSociete(societeId) {
      const societeFind = this.societesInformations.find((s) => {
        return s.id === societeId;
      });
      return societeFind ? societeFind.libelle : null;
    },
    getAffectationSort(allAffectation, etatObtenu, referenceType, referenceEtat) {
      const affectations = allAffectation.filter((affectation) => {
        return affectation.etatObtenu === etatObtenu && referenceType === affectation.typeReference
          && referenceEtat === affectation.etatReference;
      });
      affectations.sort((a, b) => {
        if (a.nbFaces < b.nbFaces
          || (a.nbFaces === b.nbFaces && a.libelle.localeCompare(b.libelle) > 0)) {
          return 1;
        }
        if (a.nbFaces > b.nbFaces
          || (a.nbFaces === b.nbFaces && a.libelle.localeCompare(b.libelle) < 0)) {
          return -1;
        }
        return 0;
      });
      return affectations;
    },
    getFormatReseau(formatId) {
      const findFormat = this.parametre(typesParametres.PARAMETRES_KEYS.format).find((format) => {
        return format.id === formatId;
      });
      return findFormat ? findFormat.libelle : null;
    },
    getAffectationOptionSort(allAffectation) {
      return allAffectation
        .filter((affectation) => {
          return affectation.typeReference === TYPE_DEVIS && affectation.etatObtenu === OPTION;
        })
        .sort((a, b) => {
          if (a.rangOption < b.rangOption) { return -1; }
          if (a.rangOption > b.rangOption) { return 1; }
          return 0;
        });
    },
  },
};
</script>
